import React from 'react';
import { arrayOf, func, string, shape } from 'prop-types';
import { Image } from '@thd-olt-component-react/core-ui';
import { Col } from '@thd-olt-component-react/grid';
import styles from './preview.module.scss';

export const Preview = ({ url, onClick, thumbnails }) => {

  const handlePreviewClick = () => {
    onClick();
  };

  return (
    <button onClick={handlePreviewClick} type="button">
      <div className={styles.preview}>
        <div className={styles.preview__thumbnails}>
          {
            [1, 2, 3].map((thumbnailNumber, thumbnailIndex) => {
              const thumbnailUrl = thumbnails?.length >= thumbnailIndex && thumbnails?.[thumbnailIndex]?.url;
              return (
                <Col className={styles.preview__thumbnail} fallback="4" nopadding key={thumbnailIndex}>
                  {
                    thumbnailUrl ? (
                      <Image
                        alt="Product Image"
                        className={styles.preview__image}
                        src={thumbnailUrl}
                        height="1"
                        width="1"
                      />
                    ) : (
                      <div className={styles.preview__placeholder} />
                    )
                  }
                </Col>
              );
            })
          }
        </div>
      </div>
    </button>
  );
};

Preview.displayName = 'ListTilePreview';

Preview.propTypes = {
  onClick: func.isRequired,
  url: string.isRequired,
  thumbnails: arrayOf(shape({
    url: string
  })),
};

Preview.defaultProps = {
  thumbnails: []
};
